import React from 'react'

export const EyeIcon = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
    >
        <path
            d="M8.99994 12.2474C7.20744 12.2474 5.75244 10.7924 5.75244 8.99994C5.75244 7.20744 7.20744 5.75244 8.99994 5.75244C10.7924 5.75244 12.2474 7.20744 12.2474 8.99994C12.2474 10.7924 10.7924 12.2474 8.99994 12.2474ZM8.99994 6.87744C7.82994 6.87744 6.87744 7.82994 6.87744 8.99994C6.87744 10.1699 7.82994 11.1224 8.99994 11.1224C10.1699 11.1224 11.1224 10.1699 11.1224 8.99994C11.1224 7.82994 10.1699 6.87744 8.99994 6.87744Z"
            fill="#9F99AA"
        />
        <path
            d="M9.00006 15.7651C6.18006 15.7651 3.51756 14.1151 1.68756 11.2501C0.892559 10.0126 0.892559 7.99511 1.68756 6.75011C3.52506 3.88511 6.18756 2.23511 9.00006 2.23511C11.8126 2.23511 14.4751 3.88511 16.3051 6.75011C17.1001 7.98761 17.1001 10.0051 16.3051 11.2501C14.4751 14.1151 11.8126 15.7651 9.00006 15.7651ZM9.00006 3.36011C6.57756 3.36011 4.26006 4.81511 2.64006 7.35761C2.07756 8.23511 2.07756 9.76511 2.64006 10.6426C4.26006 13.1851 6.57756 14.6401 9.00006 14.6401C11.4226 14.6401 13.7401 13.1851 15.3601 10.6426C15.9226 9.76511 15.9226 8.23511 15.3601 7.35761C13.7401 4.81511 11.4226 3.36011 9.00006 3.36011Z"
            fill="#9F99AA"
        />
    </svg>
)

export const EyeSlashIcon = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity: 0.6, pointerEvents: 'none' }}
    >
        <path
            d="M8.99994 12.2474C7.20744 12.2474 5.75244 10.7924 5.75244 8.99994C5.75244 7.20744 7.20744 5.75244 8.99994 5.75244C10.7924 5.75244 12.2474 7.20744 12.2474 8.99994C12.2474 10.7924 10.7924 12.2474 8.99994 12.2474ZM8.99994 6.87744C7.82994 6.87744 6.87744 7.82994 6.87744 8.99994C6.87744 10.1699 7.82994 11.1224 8.99994 11.1224C10.1699 11.1224 11.1224 10.1699 11.1224 8.99994C11.1224 7.82994 10.1699 6.87744 8.99994 6.87744Z"
            fill="#9F99AA"
        />
        <path
            d="M9.00006 15.7651C6.18006 15.7651 3.51756 14.1151 1.68756 11.2501C0.892559 10.0126 0.892559 7.99511 1.68756 6.75011C3.52506 3.88511 6.18756 2.23511 9.00006 2.23511C11.8126 2.23511 14.4751 3.88511 16.3051 6.75011C17.1001 7.98761 17.1001 10.0051 16.3051 11.2501C14.4751 14.1151 11.8126 15.7651 9.00006 15.7651ZM9.00006 3.36011C6.57756 3.36011 4.26006 4.81511 2.64006 7.35761C2.07756 8.23511 2.07756 9.76511 2.64006 10.6426C4.26006 13.1851 6.57756 14.6401 9.00006 14.6401C11.4226 14.6401 13.7401 13.1851 15.3601 10.6426C15.9226 9.76511 15.9226 8.23511 15.3601 7.35761C13.7401 4.81511 11.4226 3.36011 9.00006 3.36011Z"
            fill="#9F99AA"
        />
        <line
            x1="0"
            y1="0"
            x2="18"
            y2="18"
            stroke="#9F99AA"
            strokeWidth="1.5"
        />
    </svg>
)
